import { CreateTenantRequest } from 'src/features/tenants/api/tenantApiTypes';
import { TenantFormData } from 'src/features/tenants/types/tenantForm.types';

export function createTenantRequestFactory(
  formData: TenantFormData
): CreateTenantRequest | undefined {
  const { initialData, settings, domains } = formData;

  if (!domains.add || domains.add.length === 0) {
    console.log('domains must be defined at creation');
    return undefined;
  }
  return {
    initialData: {
      ...initialData,
      document: initialData.document.replace(/\D/g, ''),
    },
    settings: settings?.add
      ? {
          add: settings.add.map(setting => ({
            configKeyContext: String(setting.configKeyContext),
            configKeyDescription: setting.configKeyDescription ?? undefined,
            configKey: String(setting.configKey),
            configValue: String(setting.configValue),
            encrypted: setting.encrypted === 'true',
            public: setting.public === 'true',
          })),
        }
      : undefined,
    domains: {
      add: domains.add.map(domain => ({
        domain: String(domain.domain),
        isPrimary: domain.isPrimary,
      })),
    },
  };
}
